import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

export default function AddLeaveModal({ show, setShow }) {

const [fromDate, setFromDate] = useState(null);
const [toDate, setToDate] = useState(null);

return (

<Modal
show={show}
onHide={() => setShow(false)}
centered
dialogClassName="leave-modal"
>

<Modal.Header closeButton>

<Modal.Title>Add Leave</Modal.Title>

</Modal.Header>


<Modal.Body>

<Form>

{/* Employee Name */}

<Form.Group className="mb-3">

<Form.Label>Employee Name</Form.Label>

<Form.Select className="custom-select">

<option>Select</option>
<option>Anthony Lewis</option>
<option>Brian Villalobos</option>
<option>Harvey Smith</option>

</Form.Select>

</Form.Group>


{/* Leave Type */}

<Form.Group className="mb-3">

<Form.Label>Leave Type</Form.Label>

<Form.Select className="custom-select">

<option>Select</option>
<option>Medical Leave</option>
<option>Casual Leave</option>
<option>Annual Leave</option>

</Form.Select>

</Form.Group>


<Row>

{/* FROM DATE */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>From</Form.Label>

<div className="date-input">

<DatePicker
selected={fromDate}
onChange={(date) => setFromDate(date)}
dateFormat="dd-MM-yyyy"
placeholderText="dd/mm/yyyy"
className="form-control"
/>

<FiCalendar className="date-icon"/>

</div>

</Form.Group>

</Col>


{/* TO DATE */}

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>To</Form.Label>

<div className="date-input">

<DatePicker
selected={toDate}
onChange={(date) => setToDate(date)}
dateFormat="dd-MM-yyyy"
placeholderText="dd/mm/yyyy"
className="form-control"
/>

<FiCalendar className="date-icon"/>

</div>

</Form.Group>

</Col>

</Row>


<Row>

<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>No of Days</Form.Label>

<Form.Control />

</Form.Group>

</Col>


<Col md={6}>

<Form.Group className="mb-3">

<Form.Label>Remaining Days</Form.Label>

<Form.Control />

</Form.Group>

</Col>

</Row>


<Form.Group className="mb-3">

<Form.Label>Reason</Form.Label>

<Form.Control as="textarea" rows={3}/>

</Form.Group>


</Form>

</Modal.Body>


<Modal.Footer>

<Button
variant="light"
onClick={() => setShow(false)}
>
Cancel
</Button>

<Button className="add-btn">
Add Leaves
</Button>

</Modal.Footer>


<style>{`

/* MODAL WIDTH */

.leave-modal .modal-dialog{
max-width:620px;
}

/* DATE INPUT */

.date-input{
position:relative;
}

.date-input input{
padding-right:35px;
height:42px;
}

.dropdown-toggle::after {
  display: none !important; }
.date-icon{
position:absolute;
right:12px;
top:50%;
transform:translateY(-50%);
color:#6b7280;
pointer-events:none;
}

/* SELECT ORANGE ACTIVE */

.custom-select:focus{
border-color:#f97316;
box-shadow:0 0 0 0.15rem rgba(249,115,22,0.25);
}

/* BUTTON */

.add-btn{
background:#f97316;
border:none;
padding:8px 20px;
}

.add-btn:hover{
background:#ea580c;
}

/* DATE PICKER ORANGE */

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected{
background:#f97316 !important;
}

.react-datepicker__day:hover{
background:#fed7aa !important;
}

.react-datepicker__day--today{
color:#f97316;
font-weight:600;
}

`}</style>

</Modal>

)

}